module.exports = __webpack_public_path__ + "static/media/bg-d.c88021c1.jpg";